import { Injectable } from "@angular/core";
import { TopScoresInfo } from "@model";
import { Observable } from "rxjs";
import { ScoreHttpService } from "./scores-http.service";

@Injectable({ providedIn: "root" })
export class TopScoresService {
  topScoresInfo$: Observable<TopScoresInfo>;

  constructor(private _scoresHttpService: ScoreHttpService) {
    this.topScoresInfo$ = this._scoresHttpService.loadTopScores();
  }
}
